import api from "./api";
import { getConfig } from "../runtimeConfig";

const AUTORIZACION_ENDPOINT = getConfig("AUTORIZACION_ENDPOINT", "/v1/autorizacion");

export const evaluarAutorizacion = async (solicitud) => {
    const response = await api.post(AUTORIZACION_ENDPOINT, solicitud);
    return response.data;
};
